import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Fairs.scss';

const Fairs = () => {
  const { t } = useTranslation();
  
  const fairs = [
    {
      id: 1,
      image: 'munchen.png',
      title: 'Heimtextil Frankfurt',
      date: '9-12 Ocak 2024'
    },
    {
      id: 2,
      image: 'paris.png',
      title: 'ITM İstanbul',
      date: '4-8 Haziran 2024'
    },
    {
      id: 3,
      image: 'bursa.png',
      title: 'Techtextil Frankfurt',
      date: '23-26 Nisan 2024'
    }
  ];

  return (
    <section className="fairs-section">
      <div className="section-title">
        <h2>{t('fairs.title')}</h2>
        <p>{t('fairs.subtitle')}</p>
      </div>
      <div className="container">
        <div className="fairs-wrapper">
          {fairs.map(fair => (
            <div key={fair.id} className="fair-item">
              <img src={require(`../../assets/images/${fair.image}`)} alt={fair.title} />
              <div className="fair-content">
                <h3>{fair.title}</h3>
                <p>{fair.date}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-5">
          <Link to="/fairs" className="schedule-btn">{t('fairs.view_all')}</Link>
        </div>
      </div>
    </section>
  );
};

export default Fairs;